
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.1","id":"레이어_1","xmlns":"http://www.w3.org/2000/svg","x":"0","y":"0","viewBox":"0 0 24 24","xml:space":"preserve"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"st0",attrs:{"d":"M22.2 20H4V1.8c0-.2-.2-.4-.4-.4s-.5.2-.5.4V20H1.8c-.2 0-.4.2-.4.4s.2.4.4.4h1.3v1.3c0 .2.2.4.4.4s.5-.1.5-.3v-1.3h18.2c.2 0 .4-.2.4-.4.1-.4-.1-.5-.4-.5z"}}),_c('path',{staticClass:"st0",attrs:{"d":"M3.5 23c-.5 0-.9-.4-.9-.9v-.9h-.8c-.5 0-.9-.4-.9-.9s.4-.9.9-.9h.9V1.8c0-.4.4-.8.8-.8s.9.4.9.9v17.7h17.8c.5 0 .9.4.9.9s-.4.9-.9.9H4.4v.9c0 .3-.4.7-.9.7zm-1.7-2.6h1.8v1.8-1.8h18.7H3.6V1.8v18.5H1.8z"}}),_c('g',[_c('path',{staticClass:"st0",attrs:{"d":"M5.3 19.1c-.2 0-.4-.2-.4-.4 0-.1 0-.2.1-.3L8.6 14c.1-.1.2-.2.3-.2.1 0 .3 0 .3.1l1.4 1.4 2.4-3.9c.1-.1.2-.2.4-.2.1 0 .3.1.4.2l1.2 1.5 1.6-7.5c-.1-.4.1-.5.4-.5.1 0 .2.1.2.1l2.3 2.3 2.4-3.1c.1-.2.4-.2.6-.1.2.1.2.4.1.6l-2.7 3.5c-.1.2-.4.2-.6.1l-2.1-2.1-1.6 7.6c-.1.2-.3.4-.5.3-.1 0-.2-.1-.3-.2l-1.4-1.7-2.4 4c-.1.2-.4.3-.6.2 0 0-.1 0-.1-.1l-1.4-1.4-3.3 4c0 .1-.1.2-.3.2z"}}),_c('path',{staticClass:"st0",attrs:{"d":"M5.3 19.5c-.2 0-.5-.1-.6-.3-.2-.2-.3-.4-.3-.6 0-.2.1-.4.2-.5l3.6-4.4c.2-.2.4-.3.6-.3.2 0 .5.1.7.3l1 1 2.1-3.5c.1-.2.4-.4.7-.4.3 0 .6.1.7.3l.6.8L16 5.2c.1-.5.6-.8 1-.7.2 0 .3.1.4.2l2 1.9L21.5 4c.3-.4.8-.5 1.2-.2.2.1.3.3.3.6 0 .2 0 .5-.2.6l-2.7 3.5c-.1.4-.7.5-1.1.2l-.1-.1-1.5-1.5L16 14c-.1.5-.6.8-1 .7-.2 0-.4-.2-.5-.3l-1-1.2-2 3.3c-.2.4-.8.5-1.2.3-.1 0-.1-.1-.2-.1L9 15.5l-3 3.6c-.2.3-.4.4-.7.4zm3.6-5.3l-3.6 4.4v.4-.4l3.6-4.4 1.8 1.8 2.7-4.4 1.8 2.2L17 5.4 19.6 8l2.7-3.5L19.6 8l-2.7-2.6-1.8 8.4-1.8-2.2-2.6 4.4-1.8-1.8z"}})])])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/svg/nano_w-01.svg